import keyMirror from 'react-utils/keyMirror';
export const SUBMISSIONS_PER_PAGE = 10;
export const Columns = keyMirror({
  CONTACT: null,
  CONVERSION_PAGE: null,
  PAYMENT_STATUS: null,
  SUBMITTED_ON: null,
  DELETED: null
});
export const STANDARD_COLUMN_LIST = [Columns.CONVERSION_PAGE, Columns.SUBMITTED_ON];
export const ColumnSections = keyMirror({
  COMMON: null,
  CUSTOM: null
});
export const ColumnLangKeys = {
  [Columns.CONTACT]: 'contact',
  [Columns.CONVERSION_PAGE]: 'conversionPage',
  [Columns.SUBMITTED_ON]: 'submittedOn',
  [Columns.PAYMENT_STATUS]: 'paymentStatus',
  [Columns.DELETED]: 'deleted'
};
export const Tabs = keyMirror({
  PERFORMANCE: null,
  ANSWERS: null,
  SUBMISSIONS: null
});
export const ColumnSectionLangKeys = {
  [ColumnSections.COMMON]: 'commonColumns',
  [ColumnSections.CUSTOM]: 'customColumns'
};
export const FULL_NAME_FIELDS = ['firstname', 'lastname'];
export const SIDE_PANEL_WIDTH = 600;
export const SIDE_PANEL_ID = 'form-submission-side-panel';
export const SubmissionSource = keyMirror({
  api: null,
  embed: null,
  share: null,
  collected: null,
  popup: null,
  unknown: null
});
export const SubmissionValueTypes = keyMirror({
  BOOLEAN: null,
  TIMESTAMP: null,
  DATE: null,
  PLAIN_TEXT: null,
  PAYMENT_STATUS: null,
  HTML: null,
  UNAUTHORIZED_VALUE: null
});
export const DEFAULT_NON_REMOVABLE_COLUMNS = [Columns.CONTACT, Columns.PAYMENT_STATUS];
export const RESERVED_BACKEND_COLUMN_NAMES = keyMirror({
  conversion_page_info: null,
  contact_info: null,
  timestamp: null,
  payment_status: null
});
export const EXPORT_SUBMISSIONS_COLUMN_NAMES = keyMirror({
  timestamp: null,
  conversion_page: null
});
export const RESERVED_COLUMN_NAMES = {
  [RESERVED_BACKEND_COLUMN_NAMES.conversion_page_info]: Columns.CONVERSION_PAGE,
  [RESERVED_BACKEND_COLUMN_NAMES.contact_info]: Columns.CONTACT,
  [RESERVED_BACKEND_COLUMN_NAMES.payment_status]: Columns.PAYMENT_STATUS,
  [RESERVED_BACKEND_COLUMN_NAMES.timestamp]: Columns.SUBMITTED_ON
};
export const EXPORT_COLUMN_NAMES_MAP = {
  [Columns.SUBMITTED_ON]: EXPORT_SUBMISSIONS_COLUMN_NAMES.timestamp,
  [Columns.CONVERSION_PAGE]: EXPORT_SUBMISSIONS_COLUMN_NAMES.conversion_page
};
export const VALID_INPUT_TYPES = keyMirror({
  DEFAULT: null,
  CONSENT: null
});
export const SECTION_MODE = keyMirror({
  OBJECT: null,
  PAYMENT: null,
  OTHER_VALUES: null
});